import request from '@/axios'

const { WEBPACK_GATEWAY_URL, WEBPACK_ENV } = process.env
import sha256 from 'sha256'
import utils from '../utils'

import { getPlatformUrl } from '@/config/config.js'
import xbb from '@xbb/xbb-utils'

export function chat(body) {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/ai/mcp/testChat`, {
    method: 'POST',
    headers: {},
    body,
    redirect: 'follow'
  }).then((res) => res.body)
}

export function getAnalyzeSseMsg(body, options = {}) {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/ai/chat/getSseMsg`, {
    method: 'POST',
    headers: {
      sign: createSign(body)
    },
    body: JSON.stringify(body),
    signal: options.signal,
    redirect: 'follow'
  }).then((res) => res.body)
}

// 批量分析
export const getBatchAnalyzeSSE = (data, options = {}) => {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/ai/aiCustomerAnalyst/batchAnalyze`, {
    method: 'POST',
    headers: {
      sign: createSign(data)
    },
    body: JSON.stringify(data),
    signal: options.signal,
    redirect: 'follow'
  }).then((res) => res.body)
}

// 批量分析（业务数据源分析）
export const batchAnalyze4BusinessType = (data, options = {}) => {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/ai/aiCustomerAnalyst/batchAnalyze4Biz`, {
    method: 'POST',
    headers: {
      sign: createSign(data)
    },
    body: JSON.stringify(data),
    signal: options.signal,
    redirect: 'follow'
  }).then((res) => res.body)
}

// 批量分析（陪练分析）
export const batchAnalyze4Practice = (data) => {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/ai/aiCustomerAnalyst/batchAnalyze4Practice`, {
    method: 'POST',
    headers: {
      sign: createSign(data)
    },
    body: JSON.stringify(data),
    redirect: 'follow'
  }).then((res) => res.body)
}

// 批量分析（客户分析）
export const createBusinessObjectReport = (data) => {
  let platformFlag = 'GATEWAY_URL'
  if (
    utils.xbbLocalStorageGet('platformFlag') &&
    utils.xbbLocalStorageGet('platformFlag') !== 'undefined'
  ) {
    platformFlag = utils.xbbLocalStorageGet('platformFlag')
  }
  const baseUrl =
    xbb.isDevEnv() || !utils.isMobile()
      ? WEBPACK_GATEWAY_URL
      : getPlatformUrl(platformFlag, WEBPACK_ENV)
  return fetch(`${baseUrl}/pro/v1/inside/saleOrderProcess/createBusinessObjectReport`, {
    method: 'POST',
    headers: {
      sign: createSign(data)
    },
    body: JSON.stringify(data),
    redirect: 'follow'
  }).then(async (res) => {
    if (res.status !== 200) {
      let message = `分析生成失败（${res.status}）`
      try {
        const errorData = await res.clone().json()
        message = errorData?.error || message
      } catch (e) {
        // 忽略解析失败，使用默认错误文案
      }
      const error = new Error(message)
      error.status = res.status
      throw error
    }
    return res.body
  })
}

// 分析结果
export function getAnalyzeResult(data) {
  return request({
    url: `/inside/intention/recognize/analyze`,
    data
  })
}

export function getConversionList() {
  return request({
    url: `/inside/ai/mcp/getConversationList`
  })
}

export function createConversation() {
  return request({
    url: `/inside/ai/mcp/createConversation`
  })
}

export function getConversationContentList(data) {
  return request({
    url: `/inside/ai/mcp/getConversationContentList`,
    data
  })
}

export function getAiCustomerAnalyst(data) {
  return request({
    url: `/inside/ai/aiCustomerAnalyst/analyze`,
    data
  })
}

// 清空队列
export function clearStart(data) {
  return request({
    url: '/inside/realtime/start',
    data
  })
}

// 结束实时转录
export function endAsr(data) {
  return request({
    url: '/inside/realtime/end',
    data
  })
}

// asr白名单
export function checkOpen(data) {
  return request({
    url: '/inside/realtime/checkOpen',
    data
  })
}

// 获取备份音频
export function getBackupAudio(data) {
  return request({
    url: '/inside/ai/getBackupAudio',
    data
  })
}

// 取消备份音频
export function cancelBackupAudio(data) {
  return request({
    url: '/inside/ai/cancelBackupAudio',
    data
  })
}

// asr语音转文字
export function getASRresult(body) {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/realtime/translation`, {
    method: 'POST',
    headers: {},
    body,
    redirect: 'follow'
  })
    .then((res) => res.json())
    .then((data) => data)
}

// 快捷录入语音转文字
export function getQuickEntryResult(body) {
  let platformFlag = 'GATEWAY_URL'
  if (
    utils.xbbLocalStorageGet('platformFlag') &&
    utils.xbbLocalStorageGet('platformFlag') !== 'undefined'
  ) {
    platformFlag = utils.xbbLocalStorageGet('platformFlag')
  }
  const baseUrl = xbb.isDevEnv() ? WEBPACK_GATEWAY_URL : getPlatformUrl(platformFlag, WEBPACK_ENV)
  return fetch(`${baseUrl}/pro/v1/inside/intention/recognize`, {
    method: 'POST',
    headers: {},
    body,
    redirect: 'follow'
  })
    .then((res) => res.json())
    .then((data) => data)
}

function createSign(params) {
  let bodyString = JSON.stringify(Object.assign(params))
  if (bodyString.length > 100) {
    bodyString = CharacterFilter(bodyString)
  }
  return sha256(bodyString.trim() + (utils.xbbLocalStorageGet('xbbAccessToken') || '1'))
}

function CharacterFilter(str) {
  let newStr = ''
  for (let i = 0; i < str.length; i++) {
    const us = str.charCodeAt(i)
    if (!(us < 0x20 || us === 0x7f || us === 0x2028 || us === 0x2029)) {
      newStr += str.charAt(i)
    }
  }
  return newStr
}

// 【WEB APP】授权登录保存
export function saveAuthorizationLogin(data) {
  return request({
    url: '/userAuthorization/save',
    data
  })
}

// 获取临时验证码
export function getTemporaryCode(data) {
  return request({
    url: '/inside/ai/chatbot/getTemporaryCode',
    data
  })
}

// **********************************分析师-陪练接口 START *************************************
// 生成陪练任务
export function generateTrainTaskSSE(data, options = {}) {
  return fetch(`${WEBPACK_GATEWAY_URL}/pro/v1/inside/ai/aiCustomerAnalyst/batchAnalyze4TrainTask`, {
    method: 'POST',
    headers: {
      sign: createSign(data)
    },
    body: JSON.stringify(data),
    signal: options.signal,
    redirect: 'follow'
  }).then((res) => res.body)
}

// 派发
export function dispatchTrainTask(data) {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/dispatchTrainTask',
    data
  })
}

// 批量派发
export function batchDispatchTrainTask(data) {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/batchDispatchTrainTask',
    data
  })
}
// 开始陪练
export function startTrainTask(data) {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/startTrainTask',
    data
  })
}

// 生成结果
export function createTrainResult(data) {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/createTrainResult',
    data
  })
}

// 最新的陪练结果
export function getTrainResult(data) {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/getTrainResult',
    data
  })
}

// 心跳接口
export function taskHeartbeat(data) {
  return request({
    url: '/inside/task/heartbeat',
    data
  })
}

// **********************************分析师-陪练接口 END *************************************
